export default __webpack_public_path__ + "static/media/b-rabbit.5bc0c624.png";